import React, { useState } from 'react'
import { Box, Card, CardContent, Tab, Tabs, Typography, IconButton } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { useFormFactor } from '../../../../hooks'
import { HomeContentCard } from '../home-content-card'
import { useScrollableRails } from '../../hooks/useScrollableRails'
import { HomeRailsScrollableContainer } from '../home-rails-scrollable-container'
import { HOME_SECTION_TYPE } from './home-sections'

function TabPanel (props) {
  const { children, selected, value, ...other } = props

  return (
    <Box
      role='tabpanel'
      hidden={selected !== value}
      id={`home-category-tabpanel-${value}`}
      aria-labelledby={`home-category-tab-${value}`}
      {...other}
    >
      {selected === value && <Box sx={{ p: 2 }}>{children}</Box>}
    </Box>
  )
}

function a11yProps (index) {
  return {
    id: `home-category-tab-${index}`,
    'aria-controls': `home-category-tabpanel-${index}`
  }
}

export const CategoryRails = ({ categorySection }) => {
  const { title, children, id, index } = categorySection
  const [selectedTab, setSelectedTab] = useState(children[0]?.id)
  const { isMobile } = useFormFactor()

  const selectedCategory = children.find(child => child.id === selectedTab)

  const dataTest = `home-category-${index}-rails`

  const {
    scrollContainerRef,
    canScrollLeft,
    canScrollRight,
    hasScrollableContent,
    scrollLeft,
    scrollRight,
    updateScrollState
  } = useScrollableRails(selectedCategory?.items || [])

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  const exploreMoreCta = selectedCategory && (
    <Typography variant={!isMobile ? 'caption' : undefined}>
      Explore <Link to={`/${selectedCategory.id}/${selectedCategory.staticUrl}`}>{selectedCategory.title}</Link>
    </Typography>
  )

  return (
    <Card data-test={dataTest}>
      <CardContent sx={{ m: 0, p: 0 }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', p: 2, backgroundColor: '#FBFBFB', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #E0E0E0' }}>
          <Typography>
            Because you are interested in <strong>{title}</strong>
          </Typography>
          {!isMobile && exploreMoreCta}
        </Box>
        <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: 'space-between' }}>
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            aria-label='home page category tabs'
            sx={{
              borderBottom: 'none',
              '.MuiTabs-scrollButtons.Mui-disabled': {
                opacity: 0.3
              }
            }}
            variant='scrollable'
            scrollButtons='auto'
            allowScrollButtonsMobile
          >
            {children.map((child, index) => (
              <Tab
                key={child.id}
                label={child.title}
                {...a11yProps(index)}
                value={child.id}
              />
            ))}
          </Tabs>
          {!isMobile && hasScrollableContent && (
            <Box display='flex' alignItems='center' data-test={`${dataTest}-scroll-buttons-container`} justifyContent='end'>
              {/* Left scroll arrow */}
              <IconButton
                onClick={scrollLeft}
                size='small'
                disabled={!canScrollLeft}
                data-test={`${dataTest}-scroll-left-button`}
              >
                <ChevronLeft />
              </IconButton>

              {/* Right scroll arrow */}
              <IconButton
                onClick={scrollRight}
                size='small'
                data-test={`${dataTest}-scroll-right-button`}
                disabled={!canScrollRight}
              >
                <ChevronRight />
              </IconButton>
            </Box>
          )}
        </Box>
        {children.map((child, index) => (
          <TabPanel key={child.id} selected={selectedTab} value={child.id}>

            <Box sx={{ position: 'relative' }}>

              <HomeRailsScrollableContainer
                data-test={`${dataTest}-scrollable-container`}
                scrollContainerRef={scrollContainerRef}
                onScroll={updateScrollState}
              >
                {child.items.map((item, itemIndex) => (
                  <Box
                    key={item.sk}
                    sx={{
                      minWidth: 300,
                      maxWidth: 300,
                      flexShrink: 0
                    }}
                  >
                    <HomeContentCard
                      content={item}
                      itemIndex={itemIndex}
                      extraTrackingData={{
                        rootCategory: id,
                        rootCategoryTitle: title,
                        categoryId: child.id,
                        categoryIndex: index,
                        categoryTitle: child.title
                      }}
                      dataTest={`home-category-${index}-item-${itemIndex}`}
                      railType={HOME_SECTION_TYPE.CATEGORY}
                    />
                  </Box>
                ))}
              </HomeRailsScrollableContainer>
              {isMobile && (
                <Box sx={{ mt: 2 }}>
                  {exploreMoreCta}
                </Box>
              )}
            </Box>
          </TabPanel>
        ))}
      </CardContent>
    </Card>
  )
}
